import { Col, Form, Spin } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getRequest, patchRequest, postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import InputField from "../../../common/htmlComponents/InputField";
import "../../../styles/Main.scss";
import { SuccessNotificationMsg } from "../../../utils/Notifications";

const AddPackageMaster = ({
  handleCancel,
  setReload,
  stateId,
  modalKey,
  setStateM,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const initialState = {
    country: 1,
    package_type: null,
  };
  const [state, setState] = useState(initialState);
  const [countries, setCountries] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);

  useEffect(() => {
    const zoneGetById = async () => {
      if (stateId !== null) {
        try {
          setapiLoading(true);
          const response = await getRequest(`package-type/${stateId}/`);
          if (response.data.success) {
            const { id, country_name, country_code, ...filteredResponse } =
              response.data.data;
            setState((prevState) => {
              return {
                ...filteredResponse,
              };
            });
            formRef.current.setFieldsValue({
              ...response.data.data,
              state: response.data.data.state_name,
              country: response.data.data.country_name,
            });
            setapiLoading(false);
          }
        } catch (error) {
          setapiLoading(false);
        }
      }
    };
    zoneGetById();
  }, [stateId, modalKey]);
  const getCountry = async () => {
    try {
      setapiLoading(true);
      const response = await getRequest(`country/?no_pagination=True`);

      const { data } = response.data;

      const countries = data.map((country) => ({
        id: country.id,
        name: country.name,
      }));

      setCountries(countries);

      setapiLoading(false);
    } catch (error) {
      setapiLoading(false);
    }
  };

  useEffect(() => {
    getCountry();
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const backToList = () => {
    setState(initialState);
    formRef.current.setFieldsValue(initialState);
    handleCancel();
  };

  // const handleCountryChnage = (value) => {
  //   setState((prevState) => ({
  //     ...prevState,
  //     country: value,
  //   }));
  // };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      let response;
      if (stateId === null) {
        response = await postRequest("package-type/", state);
      } else {
        response = await patchRequest(`package-type/${stateId}/`, state);
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          stateId === null
            ? t("package_type_added_successfully2")
            : t("package_type_updated_successfully2")
        );
        setState(initialState);
        setStateM((prev) => ({
          ...prev,
          page: 1,
        }));

        formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        handleCancel();
        setReload((reload) => !reload);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form
          className="ModalForm"
          onFinish={handleSubmit}
          autoComplete="off"
          ref={formRef}
          initialValues={state}
        >

          <Col md={24} className="TextFeild">
            <InputField
              name="package_type"
              value={state?.package_type}
              label={t("Name")}
              placeholder={t("Please Enter Name")}
              handleInputChange={handleInputChange}
              rules={t("Please Enter Name")}
              // pattern={"/^[A-Za-z\s]+$/"}
            //   pattern={"^[a-zA-Z ]+$"}
              max={20}
            />
          </Col>
          <div className="ModalPopupFooter">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("cancel")}
              onClick={backToList}
            />
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="Submit"
              label={t("Save")}
              loading={btnLoading}
            />
          </div>
        </Form>
      </Spin>
    </>
  );
};

AddPackageMaster.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  stateId: PropTypes.number,
  modalKey: PropTypes.bool,
  setStateM: PropTypes.func.isRequired,
};

export default AddPackageMaster;
